export interface IExtractDataFormElement {
  key: string;
  sampleValue: string;
  confidence: number;
  boundingBox?: {
    Width: number;
    Height: number;
    Left: number;
    Top: number;
  };
}

export type ExtractDataResponseType = {
  jobId: string;
  status: string;
  fileName: string;
  s3Key: string;
};

export type GetTemplateResultSuccessType = {
  forms: IExtractDataFormElement[];
  blocks: unknown[];
  text: string;
};

export type GetTemplateResultProccessType = { message: string; status: string };

export type GetTemplateResultType =
  | GetTemplateResultSuccessType
  | GetTemplateResultProccessType;

// Helper types for keyword analysis results
export interface TemplateMatch {
  documentTypeId: string;
  documentTypeName: string;
  matchedKeywords: string[];
  confidence: number;
  isBaseTemplate?: boolean;
  isConflict?: boolean;
  isDiscovery?: boolean;
  matchDetails?: {
    keyword: string;
    source: "text" | "input" | "both";
  }[];
}

export type AnalyzeKeywordsResponseType = TemplateMatch[];

export interface AnalyzeKeywordsRequest {
  text: string;
  keywords: string[];
}

export interface StructuredAnalyzeKeywordsResponse {
  testResults: TemplateMatch[];
  conflictResults: TemplateMatch[];
  discoveryResults: TemplateMatch[];
}

export const normalizeAnalysisResponse = (
  response: AnalyzeKeywordsResponseType | StructuredAnalyzeKeywordsResponse
): StructuredAnalyzeKeywordsResponse => {
  if ("testResults" in response) {
    return response;
  }
  const testResults = response.filter(
    (r) =>
      r.documentTypeId === "base-template" ||
      r.documentTypeId === "1" ||
      r.isBaseTemplate === true
  );
  const conflictResults = response.filter(
    (r) =>
      r.documentTypeId !== "base-template" &&
      r.documentTypeId !== "1" &&
      r.isBaseTemplate !== true &&
      r.matchDetails?.some((m) => m.source === "input" || m.source === "both")
  );
  const discoveryResults = response.filter(
    (r) =>
      r.documentTypeId !== "base-template" &&
      r.documentTypeId !== "1" &&
      r.isBaseTemplate !== true &&
      !r.matchDetails?.some((m) => m.source === "input" || m.source === "both")
  );
  return { testResults, conflictResults, discoveryResults };
};
